import React from "react";
import { Link } from "react-router-dom";
import styles from "./styles/LeftSection.module.scss";
// Utils
import footerConfigs from "../../../../../utils/configs/footer";

const LeftSection = () => {
  return (
    <section className={styles["left-section"]}>
      <div>
        <p className={styles.header}>دسترسی سریع</p>
        {footerConfigs.links.map((item) => (
          <Link key={item.title} to={item.link} className={styles["list-item"]}>
            {item.title}
          </Link>
        ))}
      </div>

      <div>
        <p className={styles.header}>تماس با ما</p>
        <p className={styles["list-item"]}>
          خیابان مطهری، نرسیده به میرزای شیرازی، پلاک ۲۱، واحد ۱
        </p>
        <p className={`${styles["list-item"]} ${styles["phone-number"]}`}>
          ۰۹۱۲ ۱۲۳ ۴۴۳۳
        </p>
        <p className={styles["list-item"]}>vista@vista.com</p>
      </div>
    </section>
  );
};

export default LeftSection;
